export default __webpack_public_path__ + "static/media/portadavideoconfiguracion2.9e142468.png";